<ion-content class="safe-area-top white">

    <app-modal-header></app-modal-header>

    <div class="content-spacing px-lg">

        <div class="pt-xl">
            <app-simple-input [control]="loginForm.get('email') | formControlConverter"
                              label="Email"></app-simple-input>
        </div>

        <div class="pt-md">
            <app-simple-input [control]="loginForm.get('password') | formControlConverter"
                              (keydown.enter)="onLogin()"
                              type="password"
                              label="Password"></app-simple-input>
            <div (click)="onResetPassword()"
                 class="ion-text-right pt-xsm ts-caption text-neutral-500">{{ 'Password dimenticata?' | translate }}
            </div>
        </div>

        <div class="w-100 pt-xl">
            <ion-button
                    [disabled]="loginForm.invalid || loginProgress"
                    (click)="onLogin()" class="w-100 d-flex">
                <ion-spinner *ngIf="loginProgress"
                             class="mr-sm" name="crescent"></ion-spinner>
                <span>{{ 'Accedi' | translate }}</span>
            </ion-button>

        </div>

        <div class="ts-body py-lg ion-text-center">Non hai un account?
            <span (click)="onRegister()" class="link-apperance">Registrati</span>
        </div>

    </div>
</ion-content>


